import { FormControl, Validators } from '@angular/forms';
import {
  EoFormConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';

const username = new EoInputConfig({
  name: 'username',
  label: 'Όνομα χρήστη',
  styleClass: 'col-12',
  control: new FormControl('', [Validators.required]),
  errors: {
    required: 'Το όνομα χρήστη είναι υποχρεωτικό',
  },
});

const password = new EoInputConfig({
  name: 'password',
  label: 'Κωδικός',
  type: 'password',
  styleClass: 'col-12',
  control: new FormControl('', [Validators.required]),
  errors: {
    required: 'Ο κωδικός είναι υποχρεωτικός',
  },
});

const formConfig = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [username, password],
});

export const authFormConfig: EoFormConfig = new EoFormConfig({
  submitButtonDivStyleClass: 'p-fluid',
  submitButtonLabel: 'Είσοδος στην Υπηρεσία',
  config: [formConfig],
});
